import { loadScript } from '@/utils/load-script';
import { loadStyle } from '@/utils/load-style';
import { trimEnd } from 'lodash';
import moment from 'moment';

declare global {
  const resource: typeof resourcePath;
  
  interface Window {
    resource: typeof resourcePath;
  }
}

/**
 * Зарегистрирует глобальный компонент angular
 * 
 * @param name 
 * @param options 
 * @returns 
 */
export function angularComponent(name: string, options: angular.IComponentOptions): angular.IModule {
  return window.app.component(name, options);
}

//#region Global resource('') function
/**
 * Хелпер для формирования путей к ресурсам (шаблонам)
 * Аналог оригинальной функции resource()
 * 
 * Оригинал:
 * var resource = function(x, y) {
 *     y = y || 0;
 *     return "{{ base_path }}/" +
 *         (y < 2 ? "bundles/core12carwashowner/" : "") +
 *         (y < 1 ? "js/app/" : "") + x;
 * }
 */

// Базовый путь (можно переопределить через DefinePlugin)
declare const __PUBLIC_PATH__: string | undefined;

const PUBLIC_PATH: string = typeof __PUBLIC_PATH__ !== 'undefined' ? String(__PUBLIC_PATH__) : '/';

// Путь к шаблонам (раньше было js/app/, теперь legacy/static-template/)
const TEMPLATES_PATH = 'legacy/static-template/';

/**
 * Формирует путь к ресурсу
 * 
 * @param path - относительный путь к ресурсу
 * @param level - уровень вложенности:
 *   уровень:
 *   - 0: basePath + legacy/static-template/ + path (для шаблонов)
 *   - 1: basePath + path (для статики)
 *   - >= 2: '/' + path (для API - БЕЗ basePath!)
 */
function resourcePath(path: string, level: number = 0): string {
  // API запросы (level >= 2) - без PUBLIC_PATH
  if (level >= 2) {
      return '/' + path;
  }
  
  // Статика (level = 1) - с PUBLIC_PATH, без TEMPLATES_PATH
  if (level >= 1) {
      return PUBLIC_PATH + path;
  }
  
  // Шаблоны (level = 0) - с PUBLIC_PATH и TEMPLATES_PATH
  return PUBLIC_PATH + TEMPLATES_PATH + path;
}

// Экспорт в window для legacy кода
window.resource = resourcePath;

export { resourcePath };
//#endregion

//#endregion Пощадите меня семеро!
function newTimezoneJSDate(...args: ConstructorParameters<typeof Date>): moment.Moment {
  const date = new Date(...args);
  return moment(date);
}

(window as any).newTimezoneJSDate = newTimezoneJSDate;
//#endregion

//#region Core12 CamService
let camserviceResourceLoaded = false;
let camserviceResourceLoadError: any = null;

/**
 * Загрузка стилей и скриптов сервиса видеотрансляции
 * 
 * @returns 
 */
export async function loadCamserviceResource() {
  if (camserviceResourceLoaded || camserviceResourceLoadError) {
    return;
  }

  try {
    if (!window.application?.streamServiceUrl) {
      throw new Error('Не установлен базовый URL для сервиса видеотрансдяции');
    }

    const d: string = trimEnd(window.application.streamServiceUrl, '/');

    const res = await Promise.all([
      loadStyle({ href: `${d}/static/c12-camstream.css`, skipIfExists: true }),

      loadScript({ src: `${d}/static/hls.min.js`, target: 'body', skipIfExists: true }),
      loadScript({ src: `${d}/static/jsmpeg.min.js`, target: 'body', skipIfExists: true }),
    ]);

    // NOTE: Загружаем camstream.js только после hls.min.js иначе, он не отрабатывает как должен
    res.push(
      await loadScript({ src: `${d}/static/c12-camstream.js`, target: 'body', skipIfExists: true })
    );

    camserviceResourceLoaded = true;

    return res;
  } catch (e: any) {
    camserviceResourceLoadError = e;
    throw e;
  }
}

(window as any).loadCamserviceResource = loadCamserviceResource;
//#endregion